import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";
import { HOME } from "@/constants/testIds";

export default function Testimonials() {
    const [idx, setIdx] = useState(0);
    const len = TESTIMONIALS.length;

    useEffect(() => {
        const t = setInterval(() => setIdx((i) => (i + 1) % len), 7000);
        return () => clearInterval(t);
    }, [len]);

    const prev = () => setIdx((i) => (i - 1 + len) % len);
    const next = () => setIdx((i) => (i + 1) % len);
    const item = TESTIMONIALS[idx];

    return (
        <section
            data-testid={HOME.testimonials}
            className="bg-[#0A0A0A] py-24 md:py-40 px-6 md:px-12 border-t border-b border-[#1A1A1A]"
        >
            <div className="max-w-5xl mx-auto text-center">
                <p className="overline text-[#D4AF37]">In Their Words</p>
                <div className="hairline-gold mx-auto mt-6 mb-16" />

                <div className="relative">
                    <Quote className="w-14 h-14 mx-auto text-[#D4AF37] opacity-60" strokeWidth={0.8} />
                    <blockquote
                        key={idx}
                        className="fade-in visible mt-8 font-serif-display text-2xl md:text-4xl leading-snug text-[#F1F1EE] px-4 md:px-12"
                    >
                        &ldquo;{item.quote}&rdquo;
                    </blockquote>
                    <div className="mt-10">
                        <p className="overline text-[#F1F1EE]">{item.author}</p>
                        <p className="mt-1 text-sm text-[#A8A8A8] font-light tracking-wider">{item.location}</p>
                    </div>
                </div>

                <div className="flex items-center justify-center gap-8 mt-14">
                    <button
                        type="button"
                        onClick={prev}
                        data-testid={HOME.testimonialsPrev}
                        aria-label="Previous testimonial"
                        className="w-11 h-11 rounded-full border border-[#F1F1EE]/60 text-[#F1F1EE] flex items-center justify-center hover:bg-[#F1F1EE] hover:text-[#0A0A0A] transition-colors"
                    >
                        <ChevronLeft className="w-4 h-4" strokeWidth={1.4} />
                    </button>
                    <div className="flex items-center gap-3">
                        {TESTIMONIALS.map((_, i) => (
                            <span
                                key={i}
                                className={`block h-px transition-all duration-500 ${
                                    i === idx ? "w-8 bg-[#D4AF37]" : "w-4 bg-[#3A3A3A]"
                                }`}
                            />
                        ))}
                    </div>
                    <button
                        type="button"
                        onClick={next}
                        data-testid={HOME.testimonialsNext}
                        aria-label="Next testimonial"
                        className="w-11 h-11 rounded-full border border-[#F1F1EE]/60 text-[#F1F1EE] flex items-center justify-center hover:bg-[#F1F1EE] hover:text-[#0A0A0A] transition-colors"
                    >
                        <ChevronRight className="w-4 h-4" strokeWidth={1.4} />
                    </button>
                </div>
            </div>
        </section>
    );
}
